import {createSlice} from '@reduxjs/toolkit'

const initialCurrencyState = {
  totalCount: 0,
  currencies: null,
  currency: undefined,
  currenciesDropdown: [],
}

export const CurrencySlices = createSlice({
  name: 'currencies',
  initialState: initialCurrencyState,
  reducers: {
    currency: (state, action) => {
      state.currency = action.payload.currency
    },
    currencies: (state, action) => {
      state.currencies = action.payload.currencies
      state.totalCount = action.payload.total_count
    },
    currencyDropdownList: (state, action) => {
      state.currenciesDropdown = action.payload.currencies
    },
  },
})
